import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { addDoc, collection, doc } from "firebase/firestore";
import { db, auth } from "../../services/firebase";

import { ChatInputContainer } from "./ChatInput.elements";

function ChatInput({ channelName, channelId, chatRef }) {
  const [input, setInput] = useState("");
  const user = auth.currentUser;

  const sendMessage = (e) => {
    e.preventDefault();

    if (!channelId) {
      return false;
    }

    const docRef = doc(db, "rooms", channelId);
    const msgRef = collection(docRef, "messages");

    if(input) {
      addDoc(msgRef, {
        message: input,
        timestamp: new Date(),
        user: user.displayName,
        userImage: user.photoURL,
      });
      chatRef.current.scrollIntoView({
        behavior: "smooth",
      });
  
      setInput("");
    } else {
      return;
    }

  };
  return (
    <ChatInputContainer>
      <form>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={`Message #${channelName}`}
        />
        <Button type="submit" onClick={sendMessage}>
          SEND
        </Button>
      </form>
    </ChatInputContainer>
  );
}

export default ChatInput;
